import { render, staticRenderFns } from "./ExchangeBtn.vue?vue&type=template&id=908978b2&scoped=true"
import script from "./ExchangeBtn.vue?vue&type=script&lang=js"
export * from "./ExchangeBtn.vue?vue&type=script&lang=js"
import style0 from "./ExchangeBtn.vue?vue&type=style&index=0&id=908978b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908978b2",
  null
  
)

export default component.exports